import logoFile from '../../assets/visa_logo.svg';

export const Visa = () => {
  const visaPath = logoFile as unknown as string;

  return <img alt="visa logo" src={visaPath} />;
};
